var today = new Date();
var dd = String(today.getDate()).padStart(2, "0");
var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
var yyyy = today.getFullYear();
export const CURRENT_DATE = yyyy + "-" + mm + "-" + dd;

export const spkCategoryList = ["PRODUKSI JADI", "PRODUKSI SETENGAH JADI"];

export const STOCK_ADJUSTMENT_TYPE_OPTION = [
  {
    value: "IN",
    label: "Masuk",
  },
  {
    value: "OUT",
    label: "Keluar",
  },
];

export const PRODUCTION_PRODUCT_TYPE = [
  "AYAM SATE",
  "IKAN KARYAWAN",
  "IKAN KAKAP UTUH",
  "IKAN KAKAP BADAN",
  "IKAN KAKAP FILLET",
  "IKAN GURAMI",
  "CUMI",
  "UDANG KELONG",
];

// export const BAWAL_SUB_SPEC = [
//   {
//     type: "2.5",
//     spec_detail: [
//       {
//         type: "2.4",
//         spec_min: 0.24,
//         spec_max: 0.25,
//       },
//       {
//         type: "2.5",
//         spec_min: 0.25,
//         spec_max: 0.26,
//       },
//       {
//         type: "2.6",
//         spec_min: 0.26,
//         spec_max: 0.27,
//       },
//       {
//         type: "2.7",
//         spec_min: 0.27,
//         spec_max: 0.28,
//       },
//     ],
//   },
//   {
//     type: "3",
//     spec_detail: [
//       {
//         type: "2.8",
//         spec_min: 0.28,
//         spec_max: 0.29,
//       },
//       {
//         type: "2.9",
//         spec_min: 0.29,
//         spec_max: 0.3,
//       },
//       {
//         type: "3",
//         spec_min: 0.3,
//         spec_max: 0.31,
//       },
//       {
//         type: "3.1",
//         spec_min: 0.31,
//         spec_max: 0.32,
//       },
//       {
//         type: "3.2",
//         spec_min: 0.32,
//         spec_max: 0.33,
//       },
//     ],
//   },
//   {
//     type: "3.5",
//     spec_detail: [
//       {
//         type: "3.3",
//         spec_min: 0.33,
//         spec_max: 0.34,
//       },
//       {
//         type: "3.4",
//         spec_min: 0.34,
//         spec_max: 0.35,
//       },
//       {
//         type: "3.5",
//         spec_min: 0.35,
//         spec_max: 0.36,
//       },
//       {
//         type: "3.6",
//         spec_min: 0.36,
//         spec_max: 0.37,
//       },
//       {
//         type: "3.7",
//         spec_min: 0.37,
//         spec_max: 0.38,
//       },
//     ],
//   },
//   {
//     type: "4",
//     spec_detail: [
//       {
//         type: "3.8",
//         spec_min: 0.38,
//         spec_max: 0.39,
//       },
//       {
//         type: "3.9",
//         spec_min: 0.39,
//         spec_max: 0.4,
//       },
//       {
//         type: "4",
//         spec_min: 0.4,
//         spec_max: 0.41,
//       },
//       {
//         type: "4.1",
//         spec_min: 0.41,
//         spec_max: 0.42,
//       },
//       {
//         type: "4.2",
//         spec_min: 0.42,
//         spec_max: 0.43,
//       },
//     ],
//   },
// ];

// export const AYAM_KALASAN_SUB_SPEC = [
//   {
//     type: "0.65",
//     spec_detail: [
//       {
//         type: "0.49",
//         spec_min: 0.2, // karena ada data yg diluar spec tpi tetap mau diterima jadi di set ambang ke 0.3
//         // spec_min: 0.49,
//         spec_max: 0.5,
//       },
//       {
//         type: "0.50",
//         spec_min: 0.5,
//         spec_max: 0.51,
//       },
//       {
//         type: "0.51",
//         spec_min: 0.51,
//         spec_max: 0.52,
//       },
//       {
//         type: "Out of Spec",
//         spec_min: 0.2,
//         // spec_max: 0.62,
//         spec_max: 0.52, // karena ada data yg diluar spec tpi tetap diterima jadi di set ambang ke 0.9
//       },
//     ],
//   },
//   {
//     type: "0.7",
//     spec_detail: [
//       {
//         type: "0.52",
//         spec_min: 0.52,
//         spec_max: 0.53,
//       },
//       {
//         type: "0.53",
//         spec_min: 0.53,
//         spec_max: 0.54,
//       },
//       {
//         type: "0.54",
//         spec_min: 0.54,
//         spec_max: 0.55,
//       },
//       {
//         type: "0.55",
//         spec_min: 0.55,
//         spec_max: 0.56,
//       },
//       {
//         type: "0.56",
//         spec_min: 0.56,
//         spec_max: 0.57,
//       },
//       {
//         type: "Out of Spec",
//         spec_min: 0.52,
//         // spec_max: 0.62,
//         spec_max: 0.57, // karena ada data yg diluar spec tpi tetap diterima jadi di set ambang ke 0.9
//       },
//     ],
//   },
//   {
//     type: "0.75",
//     spec_detail: [
//       {
//         type: "0.57",
//         spec_min: 0.57,
//         spec_max: 0.58,
//       },
//       {
//         type: "0.58",
//         spec_min: 0.58,
//         spec_max: 0.59,
//       },
//       {
//         type: "0.59",
//         spec_min: 0.59,
//         spec_max: 0.6,
//       },
//       {
//         type: "0.60",
//         spec_min: 0.6,
//         spec_max: 0.61,
//       },
//       {
//         type: "0.61",
//         spec_min: 0.61,
//         // spec_max: 0.62,
//         spec_max: 1.0, // karena ada data yg diluar spec tpi tetap diterima jadi di set ambang ke 0.9
//       },
//       {
//         type: "Out of Spec",
//         spec_min: 0.57,
//         // spec_max: 0.62,
//         spec_max: 1.0, // karena ada data yg diluar spec tpi tetap diterima jadi di set ambang ke 0.9
//       },
//     ],
//   },
// ];

export const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
